import React from 'react';
import SubTopicDetailDnd from "./SubTopicDetailDnd";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { setSequence } from "service/util/setSequence";

const SubTopicListDnd = ({ subTopicList, setSubTopicList }) => {
    const onDragEnd = (result) => {
        if (!result.destination) return;
        setSubTopicList((item) => setSequence(item, result.source.index, result.destination.index));
    };
    return (
        <DragDropContext onDragEnd={onDragEnd} >
            <Droppable droppableId="subTopicList">
                {(provided, snapshot) => (
                    <div
                        className={`subTopicListWrap`}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {subTopicList.map((data, index) => {
                            return (
                                <Draggable index={index} draggableId={"subTopicList" + index} >
                                    {provided => (
                                        <div key={data.id} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <SubTopicDetailDnd
                                                data={data}
                                                index={index}
                                                subTopicList={subTopicList}
                                                setSubTopicList={setSubTopicList}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default SubTopicListDnd;